export interface TranscriptLine {
  id: string;
  role: "user" | "persona";
  text: string;
  /** Typed locally (Anam does not echo sendUserMessage); dropped if the same user text arrives from Anam. */
  local?: boolean;
}

let seq = 0;

/** Anam streams a message in chunks that share an id: append to the existing line or add a new one. */
export function upsertLine(lines: TranscriptLine[], id: string, role: "user" | "persona", chunk: string): TranscriptLine[] {
  const key = `${role}:${id}`;
  const idx = lines.findIndex((l) => l.id === key);
  if (idx !== -1) {
    const next = lines.slice();
    next[idx] = { ...lines[idx]!, text: lines[idx]!.text + chunk };
    return next;
  }
  const t = chunk.trim();
  if (!t) return lines;
  const dedup = role === "user" ? lines.filter((l) => !(l.local && l.text.trim() === t)) : lines;
  return [...dedup, { id: key, role, text: chunk }];
}

export function addLocalUserLine(lines: TranscriptLine[], text: string): TranscriptLine[] {
  return [...lines, { id: `local:${++seq}`, role: "user", text: text.trim(), local: true }];
}
